Apt.fn.make('photos', {
	/**
	 * Initialize module
	 *
	 * @param {Object} [options]
	 * @returns {Object}
	 */
	init: function(options) {
		var scope = this;

		scope.filters = Apt.fn.filters().init('photos', $.extend({
			source: 'api/v1/photos',
			view: 'photos.results',
			filters: $.get('filters'),
			success: function() {
				scope.$private.bindScreenMap();
			}
		}, options));

		return scope.filters;
	},

	/**
	 * Unload module
	 */
	unload: function() {
		this.filters.$destroy();
	}
}, {
	/**
	 * Bind screen mapping
	 */
	bindScreenMap: function() {
		var scope = this;

		$.screen.map([
			{
				max: 2,
				callback: function() {
					scope.packPhotos(2);
				}
			},
			{
				min: 3,
				max: 3,
				callback: function() {
					scope.packPhotos(3);
				}
			},
			{
				min: 4,
				callback: function() {
					scope.packPhotos(4);
				}
			}
		]);
	},

	/**
	 * Pack photos into bins/columns
	 *
	 * @param {Number} bins
	 */
	packPhotos: function(bins) {
		var scope = this,
			app = scope.$public.filters.$private.results,
			indexOffset = 0,
			packed = [];

		app.$get('results').forEach(function(photo, index) {
			var height = Number(photo.preview.height);

			if (index - indexOffset < bins) {
				packed.push({
					height: height,
					photos: [photo]
				});
			} else {
				var shortest = packed.reduce(function(prev, curr) {
					return prev.height < curr.height ? prev : curr;
				});

				shortest.photos.push(photo);
				shortest.height += height;
			}
		});

		app.$set('results', packed);
	}
});